import {
    PATCH_CALENDAR_EVENT_FORM,
    INCREASE_CALENDAR_EVENT_STEP,
    DECREASE_CALENDAR_EVENT_STEP,
    SET_CALENDAR_EVENT_STEP,
    RESET_CALENDAR_EVENT_FORM
} from "./CalendarEventFormActionTypes"
import { CalendarEventForm } from "./CalendarEventForm"
import moment from "moment-timezone"

const STEPS = ["select-contact", "select-calendar", "register-event", "redirect-to-event"]

export type CalendarEventStore = {
    calendarEventForm: CalendarEventForm
    stepIndex: number
    step: string
}

const defaultCalendarForm: CalendarEventForm = {
    contactId: "",
    startAt: new Date(),
    endAt: new Date(),
    selectedCalendarId: "",
    selectedCalendarLabel: "",
    selectedCalendar: null,
    selectedCalendarDefaultLocation: "",
    timezone: moment.tz.guess()
}

const defaultState: CalendarEventStore = {
    calendarEventForm: { ...defaultCalendarForm },
    stepIndex: 0,
    step: STEPS[0]
}

function calendarEventReducer(state = defaultState, action) {
    switch (action.type) {
    case RESET_CALENDAR_EVENT_FORM:
        return {
            ...defaultState,
            calendarEventForm: {
                contactId: "",
                startAt: new Date(),
                endAt: new Date(),
                selectedCalendarId: "",
                selectedCalendarLabel: "",
                selectedCalendar: null,
                selectedCalendarDefaultLocation: "",
                timezone: moment.tz.guess()
            }
        }

    case PATCH_CALENDAR_EVENT_FORM:
        //Should work, but it's not working.
        /* const updatedCalendarEvent = { ...state.calendarEventForm, ...action.payload }
            return { ...state, ...updatedCalendarEvent } */

        const stateCopy = { ...state }
        for (const [key, value] of Object.entries(action.payload)) {
            stateCopy.calendarEventForm[key] = value
        }
        return { ...state, calendarEventForm: stateCopy.calendarEventForm }

    case INCREASE_CALENDAR_EVENT_STEP:
        state.stepIndex = state.stepIndex + 1
        state.step = STEPS[state.stepIndex]
        return { ...state }

    case DECREASE_CALENDAR_EVENT_STEP:
        state.stepIndex = state.stepIndex - 1
        state.step = STEPS[state.stepIndex]
        return { ...state }

    case SET_CALENDAR_EVENT_STEP:
        state.stepIndex = action.payload.step
        state.step = STEPS[state.stepIndex]
        return { ...state }

    default:
        return state
    }
}

export default calendarEventReducer



// WEBPACK FOOTER //
// ./src/state/calendar-event/CalendarEventFormReducer.ts